import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/system/org',
    name: 'POST_ORG',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
